import type { statistics as en } from '@/i18n/locales/en/statistics';
import type { Translation } from '@/i18n/types';

export const statistics: Translation<typeof en> = {
  panelType: {
    series: 'Serie',
    sessions: 'Sessioni',
    availability: 'Disponibilità',
  },
  status: {
    forbidden: 'Non puoi vedere questo contenuto.',
    insufficientData:
      'Non ci sono ancora abbastanza persone con dati per mostrare questo gruppo senza identificare nessuno.',
    noMetrics: 'Nessuna metrica in questo intervallo.',
    noData: 'Nessun dato in questo intervallo.',
    noSessions: 'Nessuna sessione in questo intervallo.',
    noAvailability: 'Nessun dato registrato.',
    loadFailed: 'Impossibile caricare questo pannello: {{message}}',
  },
  target: {
    you: 'Tu',
    department: 'Reparto {{name}}',
    company: 'Azienda {{name}}',
  },
  table: {
    date: 'Data',
    type: 'Tipo',
    duration: 'Durata',
    calories: 'Calorie',
    avgHeartRate: 'FC media',
    minutes: '{{count}} min',
    metric: 'Metrica',
    source: 'Origine',
    first: 'Primo',
    last: 'Ultimo',
    days: 'Giorni',
  },
  detailLink: 'Visualizza dettagli',
  range: {
    last7Days: 'Ultimi 7 giorni',
    last30Days: 'Ultimi 30 giorni',
    last90Days: 'Ultimi 90 giorni',
    thisWeek: 'Questa settimana',
    thisMonth: 'Questo mese',
    custom: 'Personalizzato…',
    from: 'Da',
    to: 'A',
  },
};
